import React, { useEffect, useState } from "react";
import { FiSearch } from "react-icons/fi";
import LoadingPage from "../Loading/loading";
import {
  doneFeedback,
  getFeedbackDone,
  getFeedbackNonDone,
  hideFeedback,
  nonDoneFeedback,
} from "../../api/feedback";
import { Cookies } from "react-cookie";

const FeedbackComponent = (props) => {
  const cookie = new Cookies();
  const [isSuper, setIsSuper] = useState(cookie.get("isSuper"));
  const [feedbacks, setFeedbacks] = useState(null);
  const [hideId, setHideId] = useState("");
  useEffect(() => {
    feedbackGet();
  }, []);

  const feedbackGet = () => {
    if (props.done) {
      getFeedbackDone().then((result) => {
        setFeedbacks(result.data.response);
      });
    } else {
      getFeedbackNonDone().then((result) => {
        setFeedbacks(result.data.response);
      });
    }
  };

  const hide = (id) => {
    hideFeedback(id).then((result) => {
      feedbackGet();
      setHideId("");
    });
  };

  const done = (id) => {
    doneFeedback(id).then((result) => {
      setFeedbacks(feedbacks.filter((feedback) => feedback._id !== id));
    });
  };

  const nonDone = (id) => {
    nonDoneFeedback(id).then((result) => {
      setFeedbacks(feedbacks.filter((feedback) => feedback._id !== id));
    });
  };

  return (
    <>
      {feedbacks === null ? (
        <LoadingPage />
      ) : (
        <div>
          <div className="card-cards">
            {feedbacks?.map((feedback) => (
              <div key={feedback._id} className={`card-card`}>
                <div className="card-info">
                  <div>
                    <p className="line">
                      <span className="label">Name:</span>{" "}
                      {feedback?.user_id?.name}
                    </p>
                    <p className="line">
                      <span className="label">Phone from user data:</span>{" "}
                      {feedback?.user_id?.phone}
                    </p>
                    <p className="line">
                      <span className="label">User type:</span>{" "}
                      {feedback?.user_id?.user_type}
                    </p>
                    <p className="line">
                      <span className="label">Create at:</span>{" "}
                      {feedback.createdAt.split("T")[0]}
                    </p>
                    <p className="line">
                      <span className="label">Rate:</span> {feedback.rate}
                    </p>
                    <p className="line">
                      <span className="label">Message:</span> {feedback.message}
                    </p>
                    {hideId === feedback._id && (
                      <div
                        style={{
                          border: "1px solid #ddd",
                          borderRadius: "4px",
                          padding: "5px",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        <p className="line">
                          Are you sure you want to delete this?{" "}
                        </p>
                        <div className="card-info">
                          <div className="card-actions">
                            <button
                              onClick={() => {
                                setHideId("");
                              }}
                              className="action-btn accept-btn"
                            >
                              No
                            </button>
                          </div>
                          <div className="card-actions">
                            <button
                              onClick={() => {
                                hide(feedback._id);
                              }}
                              className="action-btn remove-btn"
                            >
                              Yes
                            </button>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>

                <div>
                  {props.done ? (
                    <div className="card-actions">
                      <button
                        onClick={() => {
                          {
                            nonDone(feedback._id);
                          }
                        }}
                        className={`action-btn remove-btn`}
                      >
                        Non done
                      </button>
                    </div>
                  ) : (
                    <div className="card-actions">
                      <button
                        onClick={() => {
                          {
                            done(feedback._id);
                          }
                        }}
                        className="action-btn accept-btn"
                      >
                        Done
                      </button>
                    </div>
                  )}
                  <div style={{ height: "10px" }}></div>
                  {isSuper && hideId === "" && (
                    <button
                      onClick={() => {
                        setHideId(feedback._id);
                      }}
                      className="action-btn remove-btn"
                    >
                      Delete
                    </button>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </>
  );
};

export default FeedbackComponent;
